import { saveChecker } from '../../../Reducers/Lender/saveStatusChecker/saveStatusChecker'
export const saveStatusChecker = (item) => {

    return dispatch => {
        dispatch(saveChecker(item));
        }
}